export default function strNormalize(str: string) {
    return str.normalize("NFD").replace(/\p{Diacritic}/gu, "");
}